import React from "react";

const chiefHealthOfficerLink = (
  <span>
    Data obtained from the{" "}
    <a
      href="https://www.health.qld.gov.au/research-reports/reports/public-health/cho-report/current"
      rel="noopener noreferrer"
      target="_blank"
    >
      2020 Chief Health Officer report
    </a>
  </span>
);

const definitions = {
  revenue: { label: `Income generated from an HHS's activities.` },
  ratesAndAnnualCharges: null,
  userChargesAndFees: null,
  interestAndInvestmentRevenue: null,
  otherRevenue: null,
  grantsAndContributionsProvidedForOperating: null,
  grantsAndContributionsProvidedForCapital: null,
  netGainsFromTheDisposalsOfAssets: null,
  NetShareOfInterestsInJointVenturesAndAssociates: null,
  expenses: { label: `Payments required to deliver an HHS's activities.` },
  employeeBenefitsAndOnCosts: null,
  borrowingCosts: null,
  materialsAndContracts: null,
  depreciationAndAmortisation: null,
  impairment: null,
  otherExpenses: null,
  netLossesFromDisposalOfAssets: null,
  hospitalisations201819AllCausesCount: {
    source: chiefHealthOfficerLink,
    label:
      "Count is the number of hospitalisations of Queensland residents in Queensland.",
  },
  hospitalisations201819AllCausesAsr: {
    label:
      "ASR is age standardised rate (per 100,000 persons) standardised to Australian population 2001 using 5 year age groups to 85+.",
    source: chiefHealthOfficerLink,
  },
  potentiallyPreventable201819: {
    source: chiefHealthOfficerLink,
  },
  lifestyleRelated201819: {
    source: chiefHealthOfficerLink,
  },
  cancerIncidenceAllCancersCases20152017: {
    source: chiefHealthOfficerLink,
  },
  cancerIncidenceAllCancersCrude20152017: {
    source: chiefHealthOfficerLink,
  },
  operatingResult: {
    label:
      "Operating surplus or deficit after expenses are deducted from revenue. Excludes the impact of extraordinary events such as amalgamations and boundary adjustments.",
  },
  assets: {
    label: `A resource an HHS controls that will provide a future benefit (for example, cash, land and buildings).`,
  },
  currentAssets: {
    label:
      "An asset that is available for use, or is expected to be consumed in a short time, usually 12 months (for example cash).",
  },
  nonCurrentAssets: {
    label:
      "An asset that is not a current asset (for example land and buildings)",
  },
  liabilities: {
    label: `An HHS's obligations to make future payments (for example, payables, borrowings and employee entitlements).`,
  },
  currentLiabilities: {
    label:
      "A liability that may be required to be settled in a short time, usually 12 months (for example payables due in 30 days).",
  },

  nonCurrentLiabilities: {
    label:
      "A liability that is not a current liability (for example long term borrowings).",
  },
  operatingPerformance: {
    label:
      "How well an HHS keeps operating expenses within operating revenue. The Office of Local Government (OLG) sets a benchmark greater than zero per cent for this measure. ",
  },
  ownSourceOperatingRevenue: {
    label:
      "Degree to which a Council relies on external funding sources. More than 60 per cent of total revenue is the OLG benchmark. ",
  },
  unrestrictedCurrentRatio: `An HHS's ability to meet its short-term obligations as they fall due. OLG sets a benchmark of greater than 1.5 times.`,
  debtServiceCoverRatio: {
    label:
      "Operating cash available to service an HHS's debt. OLG benchmark is to have cash greater than twice the amount required to service debt.",
  },
};

const DefinitionMapper = (key) => {
  return definitions[key] ? definitions[key] : { label: null, source: null };
};

export default DefinitionMapper;



// WEBPACK FOOTER //
// ./src/helpers/definition-mapper.js